import { render, staticRenderFns } from "./RoomPriceForm.vue?vue&type=template&id=5243630d"
import script from "./RoomPriceForm.vue?vue&type=script&lang=ts"
export * from "./RoomPriceForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports